// extracted by mini-css-extract-plugin
export default {"row":"PrewContentFromFile_row__cEra-","col":"PrewContentFromFile_col__ob8rQ"};